// Separate opt-in V2 entry points. Classic contract routes retain their original components.
const meta = { hideBottomNavigation: true, hideAvatar: true, hideLogo: true, hideAppBar: true, fullWidth: true }
export default [
  { name: "contractWorkspacePublic", path: "/contract/new/:studioId?", meta,
    component: () => import(/* webpackChunkName: "contract-workspace-public" */ "@/views/dashboard/contract/v2/ContractPublic.vue") },
  { name: "contractWorkspacePortal", path: "/contract/my-v2", meta,
    component: () => import(/* webpackChunkName: "contract-workspace-public" */ "@/views/dashboard/contract/v2/ContractPortal.vue") },
]
